import { ConfigProvider } from "antd";
import "antd/dist/reset.css";
import React, { useEffect } from "react";
import { Provider, useSelector } from "react-redux"; // Add useSelector
import { PersistGate } from "redux-persist/integration/react";
import { ProjectName } from "./config";
import { persistor, store } from "./redux/store";
import Routers from "./routers";
import GlobalStyles from "./styles/GlobalStyles";

// Create a wrapper component to access Redux state
function PendoWrapper({ children }) {
  // Assuming your user data lives in state.user.user based on your dispatch
  const userData = useSelector((state) => state.user?.user);

  useEffect(() => {
    // Only initialize if we have user data and Pendo snippet is loaded in index.html
    if (userData && window.pendo && typeof window.pendo.initialize === 'function') {
      window.pendo.initialize({
        visitor: {
          id: userData.user_data?.id || userData.id, // Use the same ID logic as your login page
          email: userData.user_data?.email,
          role: userData.user_data?.user_type,
          // You can add custom fields here
          full_name: userData.user_data?.name
        }
      });
      console.log("Pendo Initialized for:", userData.user_data?.id);
    }
  }, [userData]); // This triggers whenever the user logs in or out

  return children;
}

function App() {
  document.title = ProjectName;

  return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          {/* Wrap everything in PendoWrapper so it can listen to the Store */}
          <PendoWrapper>
            <ConfigProvider theme={{ /* ... your existing theme ... */ }}>
              <GlobalStyles />
              <Routers />
            </ConfigProvider>
          </PendoWrapper>
        </PersistGate>
      </Provider>
  );
}

export default App;